<template>
  <div class="play-progress-loading-box">
    <div :class="{'show-flex-box-r':true,'loading-status-style': !isPause}">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
module.exports = {
  props: {
    isPause: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    
  }
};
</script>

<style lang="less">
  .play-progress-loading-box {
    &>div {
      align-items: flex-end;
      height: 0.22rem;
      &>span {
        width: 0.04rem;
        height: 0.22rem;
        border-radius: 0.04rem;
        background: #fff;
        margin-right: 0.04rem;
      }
      &>span:nth-child(1) {
        height: 0.1rem;
      }
      &>span:nth-child(2) {
        height: 0.22rem;
      }
      &>span:nth-child(3) {
        height: 0.14rem;
      }
      &>span:nth-child(4) {
        height: 0.16rem;
        margin-right: 0;
      }
    }
    &>.loading-status-style {
      &>span:nth-child(1) {
        animation: playAnimate 0.8s ease infinite alternate;
      }
      &>span:nth-child(2) {
        animation: playAnimate 1s ease infinite alternate;
      }
      &>span:nth-child(3) {
        animation: playAnimate 1.2s ease infinite alternate;
      }
      &>span:nth-child(4) {
        animation: playAnimate 1.4s ease infinite alternate;
      }

      @keyframes playAnimate {
        from {
          height: 0;
        }
        to {
          height: 0.22rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/child/play_progress_loading.vue